import type { KPICardColor } from './KPICard.types';

export const colorStyles: Record<KPICardColor, string> = {
  emerald:
    'bg-emerald-50 dark:bg-emerald-950/30 border-emerald-200 dark:border-emerald-800 text-emerald-600 dark:text-emerald-400',
  amber:
    'bg-amber-50 dark:bg-amber-950/30 border-amber-200 dark:border-amber-800 text-amber-600 dark:text-amber-400',
  rose: 'bg-rose-50 dark:bg-rose-950/30 border-rose-200 dark:border-rose-800 text-rose-600 dark:text-rose-400',
  slate: 'bg-slate-50 dark:bg-slate-800/50 border-slate-200 dark:border-slate-700 text-slate-600 dark:text-slate-400',
};

export const cardBase =
  'p-4 rounded-lg border cursor-pointer transition-all';

export const activeRing = 'ring-2 ring-offset-2 ring-indigo-500 dark:ring-offset-slate-900';
